<template>
  <div>
    <MainLayout>
      <JobsList />
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import JobsList from './JobsList.vue';

export default {
  components: {
    MainLayout,
    JobsList,
  },
};
</script>
